import React, { ComponentProps } from "react";

export default function PhotoIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M2.45833 15.4167C1.76806 15.4167 1.18576 15.1771 0.711458 14.6979C0.237153 14.2188 0 13.6389 0 12.9583V2.45833C0 1.77778 0.237153 1.19792 0.711458 0.71875C1.18576 0.239583 1.76806 0 2.45833 0H12.9583C13.6486 0 14.2309 0.239583 14.7052 0.71875C15.1795 1.19792 15.4167 1.77778 15.4167 2.45833V12.9583C15.4167 13.6389 15.1795 14.2188 14.7052 14.6979C14.2309 15.1771 13.6486 15.4167 12.9583 15.4167H2.45833ZM4.04167 11.9583H11.379C11.6402 11.9583 11.8194 11.8472 11.9167 11.625C12.0139 11.4028 11.9931 11.1875 11.8542 10.9792L9.6875 7.97917C9.57292 7.79861 9.41319 7.70486 9.20833 7.69792C9.00347 7.69097 8.83681 7.77778 8.70833 7.95833L6.95833 10.2917L5.95833 8.95833C5.82986 8.77778 5.66319 8.69097 5.45833 8.69792C5.25347 8.70486 5.09375 8.79861 4.97917 8.97917L3.56625 10.9798C3.42486 11.1877 3.40451 11.4028 3.50521 11.625C3.6059 11.8472 3.78472 11.9583 4.04167 11.9583Z"
        fill="#7E43FF"
      />
      <path
        d="M2.45833 15.4167C1.76806 15.4167 1.18576 15.1771 0.711458 14.6979C0.237153 14.2188 0 13.6389 0 12.9583V2.45833C0 1.77778 0.237153 1.19792 0.711458 0.71875C1.18576 0.239583 1.76806 0 2.45833 0H12.9583C13.6486 0 14.2309 0.239583 14.7052 0.71875C15.1795 1.19792 15.4167 1.77778 15.4167 2.45833V12.9583C15.4167 13.6389 15.1795 14.2188 14.7052 14.6979C14.2309 15.1771 13.6486 15.4167 12.9583 15.4167H2.45833ZM4.04167 11.9583H11.379C11.6402 11.9583 11.8194 11.8472 11.9167 11.625C12.0139 11.4028 11.9931 11.1875 11.8542 10.9792L9.6875 7.97917C9.57292 7.79861 9.41319 7.70486 9.20833 7.69792C9.00347 7.69097 8.83681 7.77778 8.70833 7.95833L6.95833 10.2917L5.95833 8.95833C5.82986 8.77778 5.66319 8.69097 5.45833 8.69792C5.25347 8.70486 5.09375 8.79861 4.97917 8.97917L3.56625 10.9798C3.42486 11.1877 3.40451 11.4028 3.50521 11.625C3.6059 11.8472 3.78472 11.9583 4.04167 11.9583Z"
        fill="url(#paint0_linear_1989_8735)"
        fillOpacity="0.16"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1989_8735"
          x1="7.70833"
          y1="0"
          x2="7.70833"
          y2="15.4167"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
